/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import client from 'client';
import config from 'config';
import BrandingActionTypes from '../types/branding';

export const fetchDefaultBranding = () => async (dispatch) => {
  try {
    await dispatch({
      type: BrandingActionTypes.LOAD_BRANDING_REQUEST,
    });

    let branding = null;
    if (config.organizationId !== '') {
      const { data } = await client.get(`/apis/v2/organizations_public/${config.organizationId}/business_profile`);
      branding = data?.data?.attributes?.branding;
    }

    if (!branding) {
      const { data } = await client.get('/apis/v2/organizations_public/default_branding');
      branding = data;
    }

    await dispatch({
      type: BrandingActionTypes.LOAD_BRANDING_SUCCESS,
      payload: { data: branding || {} },
    });
  } catch (error) {
    await dispatch({
      type: BrandingActionTypes.LOAD_BRANDING_FAILURE,
      error,
    });
  }
};
